/**
 * DIEUKYDIEU.TV - MEDIA CINEMA & LIGHTBOX MODAL HANDLER (JS/MEDIA-MODAL.JS)
 * Cinema Video Modal & Apple Lightbox Modal Logic (< 120 lines)
 */

import { videoList, galleryList, featuredMedia, musicList } from './media-data.js';

let currentLightboxIndex = 0;

export function openVideoCinema(videoId) {
    const video = (videoId === featuredMedia.id) 
        ? featuredMedia 
        : (videoList.find(v => v.id === videoId) || (musicList && musicList.find(m => m.id === videoId)));
    if (!video) return;

    const modal = document.getElementById('video-cinema-modal');
    const titleEl = document.getElementById('cinema-video-title');
    const artistEl = document.getElementById('cinema-video-artist');
    const iframeEl = document.getElementById('cinema-video-iframe');
    const extLink = document.getElementById('cinema-ext-link');

    if (titleEl) titleEl.innerText = video.title;
    if (artistEl) artistEl.innerText = `${video.artist} • ${video.tag}`;
    if (iframeEl) iframeEl.src = video.embedUrl;
    if (extLink) extLink.href = video.embedUrl.replace('/embed/', '/video/');

    if (modal) {
        modal.showModal ? modal.showModal() : modal.setAttribute('open', '');
    }
}

export function closeVideoCinema() {
    const modal = document.getElementById('video-cinema-modal');
    const iframeEl = document.getElementById('cinema-video-iframe');
    if (iframeEl) iframeEl.src = '';
    if (modal) {
        modal.close ? modal.close() : modal.removeAttribute('open');
    }
}

export function openMediaLightbox(id) {
    const idx = galleryList.findIndex(g => g.id === id);
    if (idx === -1) return;
    currentLightboxIndex = idx;
    updateLightboxUI();

    const modal = document.getElementById('media-lightbox-modal');
    if (modal) {
        modal.showModal ? modal.showModal() : modal.setAttribute('open', '');
    }
}

export function closeMediaLightbox() {
    const modal = document.getElementById('media-lightbox-modal');
    if (modal) {
        modal.close ? modal.close() : modal.removeAttribute('open');
    }
}

export function navigateMediaLightbox(dir) {
    currentLightboxIndex = (currentLightboxIndex + dir + galleryList.length) % galleryList.length;
    updateLightboxUI();
}

function updateLightboxUI() {
    const item = galleryList[currentLightboxIndex];
    if (!item) return;

    const img = document.getElementById('lightbox-img');
    const title = document.getElementById('lightbox-title');
    const desc = document.getElementById('lightbox-desc');
    const counter = document.getElementById('lightbox-counter');
    const dl = document.getElementById('lightbox-download-link');

    if (img) { img.src = item.highRes || item.img; img.alt = item.title; }
    if (title) title.innerText = item.title;
    if (desc) desc.innerText = `${item.author} — ${item.description}`;
    if (counter) counter.innerText = `${currentLightboxIndex + 1} / ${galleryList.length}`;
    if (dl) dl.href = item.highRes || item.img;
}

export function initMediaModalEvents() {
    if (typeof window === 'undefined') return;
    window.addEventListener('keydown', (e) => {
        const cinema = document.getElementById('video-cinema-modal');
        if (cinema && (cinema.open || cinema.hasAttribute('open')) && e.key === 'Escape') {
            closeVideoCinema();
        }
        const lightbox = document.getElementById('media-lightbox-modal');
        if (lightbox && (lightbox.open || lightbox.hasAttribute('open'))) {
            if (e.key === 'Escape') closeMediaLightbox();
            if (e.key === 'ArrowLeft') navigateMediaLightbox(-1);
            if (e.key === 'ArrowRight') navigateMediaLightbox(1);
        }
    });
}
